import { ListItem, Td, Tr, UnorderedList } from "@chakra-ui/react";
import { ImportReportRowModel } from "../../clients/BackOfficeApi";
import { InfoPopover } from "../../elements/InfoPopover";
import { Issue } from "../../elements/Issue";
import { classNames } from "../../utils/classNames";

interface ImportReportSheetRowProps {
  row: ImportReportRowModel;
}

export function ImportReportSheetRow({ row }: ImportReportSheetRowProps) {
  const hasErrors = row.cells.some((cell) => cell.issues.length > 0);

  return (
    <Tr
      key={row.id}
      className={classNames(row.state.toLocaleLowerCase(), {
        "has-errors": hasErrors,
      })}
    >
      {row.cells.map((cell) => (
        <Td
          key={cell.id}
          className={classNames(cell.state.toLocaleLowerCase(), {
            "has-error": cell.issues.length > 0,
          })}
          tabIndex={cell.issues.length ? 0 : undefined}
        >
          {cell.value}
          {cell.issues.length > 0 && (
            <InfoPopover>
              <UnorderedList>
                {cell.issues.map((issue) => (
                  <ListItem key={issue.id}>
                    <Issue issue={issue} />
                  </ListItem>
                ))}
              </UnorderedList>
            </InfoPopover>
          )}
        </Td>
      ))}
    </Tr>
  );
}
